module.exports = __webpack_public_path__ + "img/Logo_Sanlam_Allianz.2155b207.png";